import React, { useEffect, useState, useRef } from 'react'
import JoditEditor from 'jodit-react'
// import 'jodit/build/jodit.min.css'

const defaultConfig = {
  readonly: false,
  height: 300,
  toolbarButtonSize: 'middle',
  toolbarAdaptive: false,
  showXPathInStatusbar: false,
  showCharsCounter: false,
  showWordsCounter: false,
  toolbar: [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'ul',
    'ol',
    'link',
    'image',
    'video',
    'source'
  ]
}

const CommonJoditEditor = ({
  value = '',
  onChange,
  config = {},
  placeholder = '',
  showHtmlToggle = true,
  saveButtonLabel = 'Save HTML',
  className = ''
}) => {
  const [editorKey, setEditorKey] = useState(0)
  const joditRef = useRef(null)

  useEffect(() => {
    setEditorKey((k) => k + 1)
  }, [value])

  return (
    <div className={className}>
      <JoditEditor
        ref={joditRef}
        key={`${editorKey}`}
        value={value || ''}
        config={{ ...defaultConfig, ...config, height: 300 }}
        tabIndex={1}
        onBlur={(newContent) => onChange(newContent)}
      />
    </div>
  )
}

export default CommonJoditEditor
